@if (isL2()) {
  <div
    class="wallet-avatar-orb"
    [style.background]="avatarConfig().bgColor"
    [style.border-color]="avatarConfig().borderColor"
  >
    <img
      src="svg/shapes/shape-{{ avatarConfig().shapeIndex }}.svg"
      alt="Wallet avatar"
      [style.filter]="avatarConfig().imgFilter"
      [style.transform]="'rotate(' + avatarConfig().rotation + 'deg)'"
    />
  </div>
} @else {
  <div
    class="wallet-profile-orb"
    [style.background]="(l1AvatarError() || !l1AvatarBaseUrl()) ? l1AvatarConfig().bgColor : null"
  >
    @if (!l1AvatarError() && l1AvatarBaseUrl()) {
      <img
        [src]="l1AvatarBaseUrl() + '/' + l1AvatarConfig().tokenId"
        alt="Wallet avatar"
        [style.filter]="l1AvatarConfig().imgFilter"
        (error)="onL1AvatarError()"
      />
    }
  </div>
}
